import {Component, Input, signal} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu';
import {RestrictedIndicatorComponent} from "../../../../shared/restricted-indicator/restricted-indicator.component";

@Component({
  selector: 'app-object-page-heading',
  imports: [
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuTrigger,
    RestrictedIndicatorComponent,
  ],
  templateUrl: './object-page-heading.component.html',
  styleUrl: './object-page-heading.component.scss'
})
export class ObjectPageHeadingComponent {
  @Input() title: string;
  @Input() image?: string;
  @Input() loading: boolean;
  @Input() placeholderIcon?: string;
  @Input() hideInfoPopover: boolean = false;
  @Input() showRestrictedIndicator?: boolean = false;
  @Input() restrictedIndicatorLabel?: string | null = null;

  imageLoadError = signal(false);
}
